<template>
  <vx-card no-shadow>
      <div v-if="hasPermission('setting.system.account')">
        <a href="#" @click="$emit('changeTab','UserSettingsInfo')">
          <h4 class="title-report font-semibold">Account</h4>
        </a>
        <p class="text-base font-medium">Manage your account</p>
      </div>
      <div v-if="hasPermission('setting.system.manage-users-and-permissions')">
        <a href="#" @click="$emit('changeTab','UserSettingsChangePassword')">
          <h4 class="title-report font-semibold">Manage Users and Permissions</h4>
        </a>
        <p class="text-base font-medium">Manage users associated with this account and Manage Permissions.</p>
      </div>
      <div v-if="hasPermission('setting.system.edit')">
        <a href="#" @click="$emit('changeTab','GroupPermission')">
          <h4 class="title-report font-semibold">Groups</h4>
        </a>
        <p class="text-base font-medium	">Manage your groups</p>
      </div>
      <div v-if="hasPermission('setting.system.pracctice-area')">
        <a href="#" @click="$emit('changeTab','CustomField')">
          <h4 class="title-report font-semibold">Practice Area</h4>
        </a>
        <p class="text-base font-medium	">Create Practice Area/Delete/Edit.</p>
      </div>
      <div v-if="hasPermission('setting.system.recover-bin')">
        <a href="#" @click="$emit('changeTab','Recovery')">
          <h4 class="title-report font-semibold">Recovery Bin</h4>
        </a>
        <p class="text-base font-medium">
          Recover recently deleted matters, persons
          companies.
        </p>
      </div>
      <div v-if="hasPermission('setting.system.security')">
        <a href="#" @click="$emit('changeTab','Security')">
          <h4 class="title-report font-semibold">Security</h4>
        </a>
        <p class="text-base font-medium">
          Manage passwords, set up two-factor authentication,
          and monitor account sessions.
        </p>
      </div>
      <div v-if="hasPermission('setting.system.plans')">
        <a href="#" @click="$emit('changeTab','Plans')">
          <h4 class="title-report font-semibold">Plans</h4>
        </a>
        <p class="text-base font-medium">
          Show plans for buy account
        </p>
      </div>
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','Documents')">-->
<!--        <h4 class="title-report font-semibold">Documents</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">-->
<!--        View your document automation merge fields.-->
<!--        Link your account to Box, Dropbox, Drive, OneDrive-->
<!--        or NetDocuments. Edit your document preview settings.-->
<!--      </p>-->
<!--    </div>-->
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','CustomField')">-->
<!--        <h4 class="title-report font-semibold">Bill Syncing</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">-->
<!--        Sync your contacts and bills with accounting software.-->
<!--      </p>-->
<!--    </div>-->
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','AggregateReporting')">-->
<!--        <h4 class="title-report font-semibold">Aggregate Reporting Participation</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">-->
<!--        Firm participation in industry-wide statistics.-->
<!--      </p>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
import mixin from '@/views/mixin/mixin'

export default {
  mixins:[mixin],
  data () {
    return {
      name   : this.$store.state.AppActiveUser.displayName,
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>


<style>
  .title-report{
    color: #3A3DBE !important;
  }
</style>
